import Axios, { AxiosInstance, AxiosRequestConfig } from "axios";
import { authUtils } from "../utils/authUtils";

type RequestOptions = Omit<AxiosRequestConfig, "auth"> & {
  auth?: boolean;
  negocioActivo?: boolean;
};

export const BASEURL = process.env.REACT_APP_BASE_URL_FASTER_API_V2;
export const FASTER_LARAVEL_API = process.env.REACT_APP_BASE_URL_FASTER_API;

class ApiService {
  axios: AxiosInstance;

  constructor() {
    this.axios = Axios.create({
      baseURL: BASEURL,
      headers: {
        "content-type": "application/json",
        "accept": "application/json",
      },
    });
  }

  post<E>(endpoint: string, body: Record<string, any>, options?: RequestOptions) {
    const config = this.getConfig(options);
    return this.axios.post<E>(endpoint, body, config);
  }

  get<E>(endpoint: string, options?: RequestOptions) {
    const config = this.getConfig(options);
    return this.axios.get<E>(endpoint, config);
  }

  put<E>(endpoint: string, body: Record<string, any>, options?: RequestOptions) {
    const config = this.getConfig(options);
    return this.axios.put<E>(endpoint, body, config);
  }

  del<E>(endpoint: string, options?: RequestOptions) {
    const config = this.getConfig(options);
    return this.axios.delete<E>(endpoint, config);
  }

  getConfig(options?: RequestOptions) {
    const config: AxiosRequestConfig = this.axios.defaults;
    if (options) {
      const { auth, negocioActivo } = options;
      if (auth || negocioActivo) {
        const token = authUtils.getToken();
        config.headers = Object.assign(
          {
            Authorization: "Bearer " + token,
          },
          config.headers
        );
      }
      if (negocioActivo) {
        const negocioId = authUtils.getNegocioId();
        config.headers = Object.assign(
          {
            Negocio: negocioId,
          },
          config.headers
        );
      }
    }
    return config;
  }
}

export default ApiService;
